import { NOW_VALUE } from '../../constants';
import { dateToTimeString } from '../../field-rule/inputs/utils';
export function resolveDefaultTimeValue(field) {
    const defaultValue = field.view?.defaultValue;
    if (defaultValue === NOW_VALUE) {
        return dateToTimeString(new Date());
    }
    return defaultValue;
}

//# sourceMappingURL=time-input-default-value.js.map